import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Table,
  Form,
} from "react-bootstrap";
import { FaPlus, FaTrash, FaEdit, FaEye } from "react-icons/fa";
import { Link } from "react-router-dom";
import { usePagination } from "../hooks/usePagination";
import Pagination from "../Components/Pagination";
import "./CustomerList.css";
import axios from "axios";



const StaffAttendanceList = () => {
  const parseDateDMY = (value) => {
    if (!value) return null;
    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return new Date(value);
    const sep = value.includes("-") ? "-" : value.includes("/") ? "/" : null;
    if (sep) {
      const parts = value.split(sep);
      if (parts.length === 3 && parts[2].length === 4) {
        const d = parseInt(parts[0], 10);
        const m = parseInt(parts[1], 10) - 1;
        const y = parseInt(parts[2], 10);
        const dt = new Date(y, m, d);
        return isNaN(dt) ? null : dt;
      }
    }
    const dt = new Date(value);
    return isNaN(dt) ? null : dt;
  };

  const [loading, setLoading] = useState(true);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [attendanceList, setAttendanceList] = useState([]);

  useEffect(() => {
    axios.post(`${API_BASE_URL}attendance_list.php`)
      .then((response) => {
        if (response.data.head.code === 200 && Array.isArray(response.data.body)) {
          setAttendanceList(response.data.body);
          // setFilteredOrders(response.data.body);

          setLoading(false);
        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          setAttendanceList([]);
          // setFilteredOrders([]);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        setAttendanceList([]);
        // setFilteredOrders([]);
        setLoading(false);
      }).finally(() => {
        // setLoading(false); // Set loading to false after API call
        setLoading(false);
      });
  }, []);

  // search + date range state (copied from OdList pattern)
  const [search, setSearch] = useState("");
  const [fromDate, setFromDate] = useState(""); // yyyy-mm-dd
  const [toDate, setToDate] = useState(""); // yyyy-mm-dd

  const handleRemoveItem = (att_id) => {
    // setAttendanceList(attendanceList.filter((item) => item.id !== id));
    axios.post(`${API_BASE_URL}attendance_delete.php`, { att_id: att_id })
      .then((response) => {
        if (response.data.head.code === 200) {
          // setCustomers(response.data.body);
          // setFilteredOrders(response.data.body);
          window.location.reload();

        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          // setCustomers([]);
          // setFilteredOrders([]);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        // setCustomers([]);
        // setFilteredOrders([]);
      }).finally(() => {
        // setLoading(false); // Set loading to false after API call
      });
  };

  const formatDateDuration = (att) => {
    // if (request.type === "Permission" && request.duration) {
    //   return `${request.leave_date} / ${request.duration} hr`;
    // } else {
    return `${att.att_date}`;
    // }
    // return att.att_date;
  };

  // filter function: search across relevant fields + date range on `date`
  const filteredAttendance = attendanceList.filter((item) => {
    const q = search.trim().toLowerCase();

    const matchesSearch =
      !q ||
      String(item.att_id).includes(q) ||
      (item.user_name && item.user_name.toLowerCase().includes(q)) ||
      (item.desig_name && item.desig_name.toLowerCase().includes(q)) ||
      (item.depart_name && item.depart_name.toLowerCase().includes(q)) ||
      (item.att_date && item.att_date.toLowerCase().includes(q)) ||
      (item.att_time && item.att_time.toLowerCase().includes(q)) ||
      (item.status && item.status.toLowerCase().includes(q));

    // const matchesDate =
    //   (!fromDate || new Date(item.att_date) >= new Date(fromDate)) &&
    //   (!toDate || new Date(item.att_date) <= new Date(toDate));

    // return matchesSearch && matchesDate;
    if (!matchesSearch) return false;

    if (fromDate || toDate) {
      const reqDate = parseDateDMY(item.att_date);
      if (!reqDate) return false;
      if (fromDate) {
        const from = new Date(fromDate + "T00:00:00");
        if (reqDate < from) return false;
      }
      if (toDate) {
        const to = new Date(toDate + "T23:59:59");
        if (reqDate > to) return false;
      }
    }

    return true;
  });

  // Pagination hook over filtered results (consistent with other pages)
  const {
    currentPage,
    totalPages,
    currentItems,
    handlePageChange,
    indexOfFirstItem,
  } = usePagination(filteredAttendance, 25); // 4 items per page as before

  return (
    <Container fluid className="my-4 outer-container">
      <h2 className="text-center">👥 Staff Attendance Records</h2>
      {/* {currentItems.length === 0 && (
        <Container fluid className="outer-container my-4">
          <Row>
            <Col>
              <div className="not-found-box">Loading...</div>
            </Col>
          </Row>
        </Container>
      )} */}
      {/* Filters row (copied search/date UI from OdList) */}
      <Row className="mb-3">
        <Col md={4} className="mb-2">
          <Form.Label>Search</Form.Label>
          <Form.Control
            placeholder="Search by name, designation, department, time, status..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </Col>

        <Col md={3} className="mb-2">
          <Form.Label>From</Form.Label>
          <Form.Control
            type="date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            placeholder="From Date"
          />
        </Col>

        <Col md={3} className="mb-2">
          <Form.Label>To</Form.Label>
          <Form.Control
            type="date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            placeholder="To Date"
          />
        </Col>

        <Col md={2} className="d-flex mt-4">
          <Button
            className="btn-top"
            onClick={() => {
              setSearch("");
              setFromDate("");
              setToDate("");
            }}
          >
            Clear Filters
          </Button>
        </Col>
      </Row>

      {/* Scrollable table container */}
      <div className="table-pagination-wrapper">
        <div className="table-pagination-content">
          <Table bordered responsive className="table-striped customer-table">
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Name</th>
                <th>Designation</th>
                <th>Department</th>
                <th>Date</th>
                <th>Time</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {currentItems.map((item, i) => (
                <tr key={item.att_id}>
                  {/* <td>{indexOfFirstItem + i + 1}</td> */}
                  <td>{currentItems.length - (indexOfFirstItem + i)}</td>
                  <td>{item.user_name}</td>
                  <td>{item.desig_name}</td>
                  <td>{item.depart_name}</td>
                  <td>{formatDateDuration(item)}</td>
                  <td>{item.att_time}</td>
                  <td>{item.status}</td>
                  <td className="action-icons">
                    <Link to={`/viewattendance/${item.att_id}`}>
                      <FaEye className="view-icon" />
                    </Link>
                    <FaTrash
                      className="delete-icon"
                      // onClick={() => handleRemoveItem(item.id)}
                      onClick={() => {
                        if (window.confirm("Are you sure you want to delete this?")) {
                          handleRemoveItem(item.att_id);
                        }
                      }}
                      style={{ cursor: "pointer" }}
                    />
                  </td>
                </tr>
              ))}
              {currentItems.length === 0 && (
                <tr>
                  <td colSpan="8" className="text-center">
                    No attendance records found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>

      {/* Common Pagination Component - Only show if more than 1 page */}
      {totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      )}
    </Container>
  );
};

export default StaffAttendanceList;
